import React, { useState, useEffect, useRef } from 'react';
 
import Cookies from 'js-cookie';
import { db, auth, RecaptchaVerifier, signInWithPhoneNumber, signOut } from '../firebase';
import './login.css';
import { QRCodeCanvas } from "qrcode.react";
import { doc, query, where, getDocs, setDoc, getDoc, collection } from "firebase/firestore";
import Lodinging from "../components/lodinging";
import PhoneCodeList from '../pages/PhoneCodeList';
import { HiQrCode } from "react-icons/hi2";
import { LuMessageSquareText } from "react-icons/lu";

let countdownStart = 10;
export default function Login() {

  const [phone, setPhone] = useState('');
  const [code, setCode] = useState('');
  const [confirmationResult, setConfirmationResult] = useState(null);
  const [error, setError] = useState('');
  const [phoneCodes, setPhoneCodes] = useState("+91");
  const [selectedCode, setSelectedCode] = useState("+91");
  const [countryname, setSelectedcountryname] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [newTokenValue, setnewTokenValue] = useState("");

  const [loading, setLoading] = useState(false);
  const deviceName = "Web";
  //timer login
  const [countdown, setCountdown] = useState(countdownStart);
  const [qrscantimer, setqrscantimer] = useState(countdownStart);
  const intervalRef = useRef(null);
  const counterRef = useRef(4);

const setupRecaptcha = () => {
  if (!window.recaptchaVerifier) {
    window.recaptchaVerifier = new RecaptchaVerifier('recaptcha-container', {
      size: 'invisible',
      callback: (response) => {
        console.log("reCAPTCHA solved:", response);
      },
      'expired-callback': () => {
        console.warn("reCAPTCHA expired.");
      }
    }, auth); // 'auth' must be already initialized
  }
};

const sendOTP = async () => {
  try {
    if (!selectedCode) {
      setError("Please select a country code.");
      return;
    }
    if (phone.length < 8) {
      setError("Enter a valid phone number.");
      return;
    }

    // Make sure this sets window.recaptchaVerifier
    setupRecaptcha();

    const appVerifier = window.recaptchaVerifier;
    if (!appVerifier) {
      throw new Error("reCAPTCHA verifier not set up properly.");
    }

    setLoading(true);

    const fullPhoneNumber = `${selectedCode.value}${phone}`;
    const confirmationResult = await signInWithPhoneNumber(auth, fullPhoneNumber, appVerifier);
    window.confirmationResult = confirmationResult;
    setConfirmationResult(confirmationResult);
    setError(`OTP sent to ${fullPhoneNumber}`);

    // Update UI (consider replacing with React state)
    document.querySelector('.phone-login-button').style.display = "none";
    document.querySelector('.otp-body-div').style.display = "block";
    document.querySelector('.codelist-input').style.display = "none";
    document.querySelector('.phone-input').disabled = true;
    document.querySelector('.otp-input').focus();

  } catch (error) {
    console.error("Error sending OTP:", error);
    setError("Error sending OTP: " + error.message);
    document.querySelector('.phone-input').focus();
  } finally {
    setLoading(false);
  }
};

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault(); // Prevent default behavior

      // Check if the currently focused element has the class 'phone-input'
      if (document.activeElement.classList.contains("phone-input")) {
        sendOTP();
      }

      // Check if the currently focused element has the class 'otp-input'
      if (document.activeElement.classList.contains("otp-input")) {
        verifyCode();
      }
    }
  };

  const verifyCode = async () => {
    let fullPhoneNumber = `${selectedCode.value.replaceAll("+", "")}${phone}`;
    try {
      if (!confirmationResult && code.length != 6) {
        setError("Please request OTP first.");
        document.querySelector('.otp-input').focus();
        return;
      }
      document.querySelector('.otp-Verify_button').textContent = "Verifying...";
      const result = await confirmationResult.confirm(code);
      console.log('User signed in:', result.user);
      setError('Phone verified!');
      // Set cookies for user session
      document.querySelector('.otp-Verify_button').textContent = "Successfully";
      const accountCollection = collection(db, "account");

      // ✅ Query Firestore for the phone number
      const q = query(accountCollection, where("phone", "==", fullPhoneNumber));
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        const uid = generateRandomString(16);
        const firstDoc = querySnapshot.docs[0];
        const account_Doc = firstDoc.data();


        const account_loginRef = doc(db, "account_login", uid);

        await setDoc(account_loginRef, {
          guid: account_Doc.guid,
          uid: uid,
          phone: result.user.phoneNumber,
          loginkey: result.user.uid,
          device: deviceName,
          otp: result.user.uid,
          deviceName: deviceName,
          app_version: '1.1.5',
          status: true,
          date_time: new Date()
        });

        Cookies.set("guid", account_Doc.guid, { expires: 365 });
        Cookies.set("aguid", account_Doc.guid, { expires: 90 });
        Cookies.set("loginkey", result.user.uid, { expires: 365 });
        //

        setTimeout(() => {
          window.location.reload(); // Reloads the page after OTP verification
        }, 2000);

      } else {
        const yearFormat = new Date().getFullYear();  // Get current year
        // Assuming a function to generate OTP
        const random_number = RandomnumString(4);  // Assuming a function to generate a 4-digit random number
        const callqr_number = `${yearFormat}${code}${random_number}`;
        // ✅ If user doesn't exist, create new user record
        const guid = generateRandomString(16);
        const newuserRef = doc(db, "account", guid);  // Set document ID as guid

        const mapdata = {
          syncid: generateRandomString(13),
          guid: guid,
          name: fullPhoneNumber,
          first_name: "",
          middle_name: "",
          last_name: "",
          profile_status: true,
          account_delete_status: false,
          gender: "Not specified",

          blood_group: "Not specified",
          blood_group_status: true,
          name_date_time: new Date(),

          about: "Available",
          photo: "https://firebasestorage.googleapis.com/v0/b/callqr-ab941.appspot.com/o/files%2Fphotos_icon.png?alt=media&token=6ceb2e92-3dc5-41a2-8901-8467b68c6822",
          photo_date_time: new Date(),
          phone: fullPhoneNumber,
          code: selectedCode.value.replaceAll("+", ""),
          otp: code,
          phone_date_time: new Date(),
          office_phone: "",
          category: "user",
          callqr_number: callqr_number,
          referral_code: "no",
          referral_earn: 0,
          referral_status: true,

          // App settings
          app_auto_update: true,
          app_update_mobile_data: true,
          app_notified_updates: true,
          app_version: "1.5.0",
          token: "null",

          currency_symbol: "₹",
          currency: "INR",
          email_status: true,
          email: "",
          email_date_time: new Date(),

          executive_guid: "",
          device: navigator.userAgent,
          device_id: deviceName,
          date_of_birth: new Date(),
          date_of_birth_status: true,
          address: "",
          address_verification_status: false,
          areas: "",
          city: "",
          zipcode: "",
          state: "",
          country: countryname,
          address_time: new Date(),

          loginkey: result.user.uid,
          status: true,
          login_date_time: new Date(),
          date_time: new Date(),
        };

        // Save to Firestore
        await setDoc(newuserRef, mapdata);

        const account_loginRef = doc(db, "account_login", guid);
        await setDoc(account_loginRef, {
          guid: guid,
          uid: guid,
          phone: selectedCode.value.replaceAll("+", ""),
          loginkey: result.user.uid,
          otp: result.user.uid,
          device: deviceName,
          app_version: '1.1.5',
          status: true,
          date_time: new Date()
        });
        Cookies.set("guid", guid, { expires: 90 });
        Cookies.set("aguid", guid, { expires: 90 });
        Cookies.set("loginkey", result.user.uid, { expires: 90 });

        console.log("✅ New user data saved to Firestore.");
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      }

    } catch (error) {
      console.error('Error verifying code:', error.message);
      setError("Error verifying code");
    }
  };

  function generateRandomString(length) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }
  function RandomnumString(length) {
    const characters = '123456789';
    let result = '';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }


  const handleChange = (selectedOption) => {
    setSelectedCode(selectedOption);
    const countryName = selectedOption.label.split(" (")[0];

    setSelectedcountryname(countryName);
    console.log("Selected Code:", selectedOption.value);

    document.querySelector('.phone-input').focus();

  };

  const startTimer = () => {
    counterRef.current = 5;

    const newToken = generateRandomString(20);
    setnewTokenValue(newToken); // updates state for UI
    setInputValue('https://callqr.com/login?token=' + newToken);

    setCountdown(countdownStart);
    setqrscantimer(countdownStart);

    clearInterval(intervalRef.current);


    intervalRef.current = setInterval(() => {
      setCountdown(prev => {
        const nextVal = prev - 1;
        setqrscantimer(nextVal);

        if (nextVal <= 0) {
          handleCheckLogin(newToken); // ✅ pass token directly
          return 0;
        }

        return nextVal;
      });
    }, 1000);
  };



  const handleCheckLogin = async (tokenToCheck) => {
    if (counterRef.current <= 0) {
      clearInterval(intervalRef.current);
      scan_login();
      return;
    }
    counterRef.current--;
    //console.log("Checking token:", tokenToCheck);

    const accountCollection2 = collection(db, "account_login");
    const q2 = query(accountCollection2, where("loginkey", "==", tokenToCheck));
    const querySnapshot2 = await getDocs(q2);

    if (!querySnapshot2.empty) {
      const firstDoc2 = querySnapshot2.docs[0];
      const account_Doc2 = firstDoc2.data();
      Cookies.set("guid", account_Doc2.guid, { expires: 90 });
      Cookies.set("loginkey", account_Doc2.loginkey, { expires: 90 });
      clearInterval(intervalRef.current);
      scan_login();
      window.location.reload();
      return;
    }

    // Retry with new token
    counterRef.current--;

    const newToken = generateRandomString(20);
    setnewTokenValue(newToken);
    setInputValue('https://callqr.com/login?token=' + newToken);
    setCountdown(countdownStart);
    setqrscantimer(countdownStart);
  };


  const scan_login = () => {
    const scanqrlogin = document.querySelector('.scanqr-login-body');
    const phonelogin = document.querySelector('.phone-login-body');
    const phoneDisplay = getComputedStyle(phonelogin).display;
    if (phoneDisplay === "none") {
      phonelogin.style.display = "block";
      scanqrlogin.style.display = "none";
      clearInterval(intervalRef.current);
    } else {
      startTimer();
      phonelogin.style.display = "none";
      scanqrlogin.style.display = "block";
    }
  }

  function generateRandomString(length) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  return (
    <div className='phone-login-container'>
<div className='login-body'> 
      <br />
      <h3>Sign in to your account</h3>
      <div className='scanqr-login-body'>
        <a>Log in by scanning with the <b>CallQR App</b>.</a>
        <br />
        <div className='timer-label'>Timer: <b>{qrscantimer} Sec</b> </div>
        <br />
        <div className='qrcode' >
          <QRCodeCanvas
            className="qrcodecanvas"
            value={(inputValue || "https://example.com")}
            size={200}
          />
          <img
            src="data:image/png;base64,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"
            alt="Callqr"
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              padding: "3px",  // Extra padding to create a better contrast
              backgroundColor: "#ffffff", // White background to prevent color loss
              transform: "translate(-50%, -50%)",
              width: "30px",
              height: "30px",
              borderRadius: "5px" // Optional: Soft shadow for better visibility
            }}
          />


        </div>
        <br />
        <div className='phonebtnlogin' onClick={scan_login}>
          <a>Log in by OTP with the <b>Phone</b>.</a>
          <LuMessageSquareText className='phone_icon' />
        </div>
      </div>
      <div className='phone-login-body'>
        <a>Login or create an account</a>
        <br />   <br />
        <div className='qrbtnlogin' onClick={scan_login}>
          <a>Log in by scanning with the <b>CallQR App</b>.</a>
          <HiQrCode className='qrcode' />
        </div>


        <PhoneCodeList
          options={phoneCodes}
          placeholder="Select country code"
          onChange={handleChange}
        />

        <div className='phone-login-div'>
          <input id='phone-input'
            className='phone-input'
            maxLength={14}
            type="tel"
            onKeyDown={handleKeyDown}
            placeholder="Phone number"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />

        </div>
        <button className='phone-login-button' onClick={sendOTP}>
          {loading ? <Lodinging /> : "Send OTP"}

        </button>
        <div id="recaptcha-container"></div>
        <div className='otp-body-div' style={{ display: 'none' }}>
          <div className='phone-login-div'>
            <input id='otp-input'
              className='otp-input'
              type="text"
              placeholder="Enter OTP"
              value={code}
              onKeyDown={handleKeyDown}
              maxLength={6}
              onChange={(e) => setCode(e.target.value)}
            />
          </div>

          <button className='otp-Verify_button' onClick={verifyCode}>
            Verify OTP
          </button>
        </div>
        {error && <a style={{ color: "red" }}>{error}</a>}
      </div>
      <div className='trams-div'>
        <div name="terms_of_service">By Get Started , you agree to the <a href='https://callqr.com/terms-of-service'>terms of service</a>.</div>
        <div name="privacy_policy">The <a href='https://callqr.com/privacy-policy'>Privacy Policy</a> explains how we handle your information.</div>
      </div>
    </div>
    </div>
  );
}
